export default __webpack_public_path__ + "static/media/icono4gris.d079fd94.svg";